import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07c22fb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = ["id"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Choose files ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: "base-file-uploader",
    for: _ctx.id
  }, [
    _createElementVNode("input", _mergeProps({
      class: "base-file-uploader__input",
      id: _ctx.id,
      type: "file"
    }, _ctx.$attrs, {
      ref: "fileInput",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileBrowsing && _ctx.handleFileBrowsing(...args)))
    }), null, 16, _hoisted_2),
    _hoisted_3
  ], 8, _hoisted_1))
}